/**
 * Add CSS classes to root node according to various informations about the device used by the user
 */
export default function osBrowserDetection() {
    const root = document.querySelector('html');

    // Add a CSS `.is-mac` class on root node if the current device is either Macintosh, Ipad or iPhone
    if(navigator.userAgent.match(/Macintosh|iPad|iPhone/)) {
        root.classList.add('is-mac');
    }
    // Add a CSS `.is-not-mac` class on root node if the current device is not Macintosh, Ipad or iPhone
    else {
        root.classList.add('is-not-mac');
    }

    // Add a CSS `.is-firefox` class on root node if the current browser is Firefox
    if(navigator.userAgent.includes('Firefox')) {
        root.classList.add('is-firefox');
    }
};